import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';

export function Quote() {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className="py-24 bg-gradient-to-br from-sky-400 to-sky-600 text-white relative overflow-hidden">
      {/* Decorative quote mark */}
      <div className="absolute -top-20 left-10 text-[20rem] opacity-10 font-serif leading-none select-none">
        &ldquo;
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <motion.blockquote
          ref={ref}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8 }}
          className="text-2xl md:text-4xl font-heading font-semibold italic leading-tight mb-8"
        >
          &ldquo;{t('quote.text')}&rdquo;
        </motion.blockquote>

        <motion.cite
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-lg tracking-widest font-bold text-sky-100 not-italic"
        >
          — {t('quote.author')}
        </motion.cite>
      </div>
    </section>
  );
}